<template>
  <div class="rejected-list">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        退换货审批意见
      </div>
      <div class="rj-page-card__content">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="approver"
            label="审批人"
            width="180"
            align="left"
          />
          <el-table-column
            prop="approvalOpinion"
            label="审批意见"
            align="left"
          />
          <el-table-column
            prop="approvalTime"
            label="审批时间"
            align="left"
            width="180"
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  }

};
</script>

<style lang="scss">

</style>
